<div class="modal-header">
    Anteprima attività
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-12">
            <table class="table table-sm" *ngIf="record">
                <tr>
                    <td>ID</td>
                    <td><b>{{record.id}}</b></td>
                </tr>
                <tr>
                    <td>Data e ora</td>
                    <td>{{record.date | date}}</td>
                </tr>

                <tr *ngIf="record.addressItem">
                    <td>Cliente</td>
                    <td>{{record.addressItem.name}}</td>
                </tr>

                <tr>
                    <td>Tipologia</td>
                    <td>
                        <span >{{searchType(record.id_type).name}}</span>
                      
                    </td>
                </tr>

                <tr>
                    <td>Descrizione</td>
                    <td><b>{{record.description}}</b></td>
                </tr>

                <tr>
                    <td>Stato</td>
                    <td>
                        <span *ngIf="record.phase==4">
                            <i  title="Doppio click per rischedulare l'attività"  class="text-warning fa fa-lg  fa-exclamation pointer"></i>
                        </span>
                        <span *ngIf="record.phase==3">
                            <i *ngIf="record.phase==3" title="Attività confermata!" class="text-success fa fa-lg  fa-check-double"></i>Attività confermata!
                        </span>
                        <span *ngIf="record.phase==2">
                            <i  title="Doppio click per confermare l'attività"  class="text-success fa  fa-check pointer"></i>Attività conclusa!
                        </span>
                        <span *ngIf="record.phase==1">
                            <i *ngIf="record.phase==1" title="Attività in corso..." class="text-warning far fa-lg  fa-clock"></i>Attività in corso...
                        </span>
                        <span *ngIf="record.phase==0">
                            <i *ngIf="record.phase==0" title="Attività da confermare da parte del cliente" class="text-warning fas fa-lg  fa-exclamation-triangle"></i>Attività da confermare da parte del cliente
                        </span>
                          

                    </td>
                </tr>
                 <tr>
                    <td>Importo richiesto</td>
                    <td><b>{{record.amount*(1+record.tax/100) | currency:"EUR"}}</b></td>
                </tr>
                <tr>
                    <td>Importo pagato</td>
                    <td><b>{{record.paid | currency:"EUR"}}</b></td>
                </tr>
                <tr>
                    <td>Tipologia di pagamento</td>
                    <td>
                        <span *ngIf="record.paid_type==1">Pagato</span>
                        <span *ngIf="record.paid_type==2">Omaggio</span>
                        <span *ngIf="record.paid_type==3">
                            Rischedulato per il {{record.reschedule_payment | date}} ({{record.note_reschedule_payment}})



                        </span>
                        

                      
                    </td>
                </tr>

                <tr>
                    <td>Operatore</td>
                    <td><b>{{record.username}}</b></td>
                </tr>

                <tr>
                    <td>ID Movimento collegato</td>
                    <td><b>{{record.id_cashflow}}</b></td>
                </tr>

                <tr>
                    <td>Documenti collegati</td>
                    <td>
                        <ul class="list-group">
                            <li class="list-group-item" *ngFor="let d of record.documents">ID {{d.id}} Num: {{d.reference}} {{d.referencecode}}</li>
                        </ul>
                       
                    </td>
                </tr>
            </table>
        </div>
        
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-outline-secondary" (click)="close()"><i class="fas fa-times mr-1"></i>Chiudi</button>
</div>
